import { fromJS, List, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { BodyList } from './body-list.model';
import { CtaPlan } from './cta-plan';
import { OptOutTrialVariantEnum } from '../../features/components/growth-dialog/growth-dialog.constant';

export const CANVAS_CONFIG_SCHEMA = Object.freeze({
  VARIANT_TYPE: OptOutTrialVariantEnum,
  BODY: '',
  BODY_LIST: List<BodyList>([]),
  CTA_1_LABEL: '',
  CTA_1_URI: '',
  CTA_2_LABEL: '',
  CTA_2_URI: '',
  CTA_INFO: '',
  DISMISSIBLE: false,
  FOOTER: '',
  HEADER: '',
  IMAGE_URI: '',
  SUBTITLE: '',
  TITLE: '',
  CTA_PLANS: List<CtaPlan>([]),
});

const RECORD = generateSchema(CANVAS_CONFIG_SCHEMA);
const KEYS: any = generateKeys(CANVAS_CONFIG_SCHEMA);

export class CanvasConfig extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.BODY_LIST,
        value: props.get(KEYS.BODY_LIST)
          ? this.bodyList.map((params) => new BodyList(params))
          : List<BodyList>(),
      },
      {
        key: KEYS.CTA_PLANS,
        value: props.get(KEYS.CTA_PLANS)
          ? this.ctaPlans.map((params) => new CtaPlan(params))
          : List<CtaPlan>(),
      },
    ]);

    return selfModel as CanvasConfig;
  }

  get variantType(): OptOutTrialVariantEnum {
    return this.get(KEYS.VARIANT_TYPE);
  }

  get body(): string {
    return this.get(KEYS.BODY);
  }

  get bodyList(): List<BodyList> {
    return this.get(KEYS.BODY_LIST);
  }

  get ctaPlans(): List<CtaPlan> {
    return this.get(KEYS.CTA_PLANS);
  }

  get cta1Label(): string {
    return this.get(KEYS.CTA_1_LABEL);
  }

  get cta1Uri(): string {
    return this.get(KEYS.CTA_1_URI);
  }

  get cta2Label(): string {
    return this.get(KEYS.CTA_2_LABEL);
  }

  get cta2Uri(): string {
    return this.get(KEYS.CTA_2_URI);
  }

  get ctaInfo(): string {
    return this.get(KEYS.CTA_INFO);
  }

  get dismissible(): boolean {
    return this.get(KEYS.DISMISSIBLE);
  }

  get footer(): string {
    return this.get(KEYS.FOOTER);
  }

  get header(): string {
    return this.get(KEYS.HEADER);
  }

  get imageUri(): string {
    return this.get(KEYS.IMAGE_URI);
  }

  get subtitle(): string {
    return this.get(KEYS.SUBTITLE);
  }

  get title(): string {
    return this.get(KEYS.TITLE);
  }
}
